module.exports = __webpack_public_path__ + "static/media/  (70).78aeeeb0.jpg";